import styled from "styled-components";

export const Period = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;

  h4 {
    margin-right: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.75);
  }

  h3 {
    font-weight: 600;
    font-size: 16;
    color: var(--light-orange);
  }
`;

export const CalendarContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Calendar = styled.aside`
  background-color: #f2f2f2;
  border-radius: 20px;
  .rdp {
    margin-bottom: 0px !important;
  }
  .selected-day {
    /* border: 2px dashed var(--dark-orange); */
    background: transparent;
  }
  .morning-filled-days {
    /* color: #fff; */
    background: linear-gradient(
      to left,
      transparent 0%,
      transparent 50%,
      var(--light-orange) 50%,
      var(--light-orange) 100%
    );
    border: 0;
  }
  .afternoon-filled-days {
    /* color: #fff; */
    background: linear-gradient(
      to right,
      transparent 0%,
      transparent 50%,
      var(--light-orange) 50%,
      var(--light-orange) 100%
    );
    border: 0;
  }
  .filled-days {
    color: #fff;
    background: var(--light-orange);
  }
  .selected-day {
    border: 2px dashed var(--dark-orange);
  }
`;

export const TotalHoursContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: center;
  padding-bottom: 10px;
`;

export const TotalHours = styled.div`
  margin-left: 6px;
  font-size: 18px;
  font-weight: 600;
  color: var(--light-orange);
`;
